import siteConfig from '@/localized/config/site';
import { domain, s2Domain, seoImagePath } from 'config/domain';

export const getHrefConfig = (locales: string[], path: string) => {
  path = path.split('?')[0];
  return locales
    ?.filter((item) => item !== 'default')
    .map((item) => ({
      href: `${domain}/${item}${path === '/' ? '' : path}`,
      hrefLang: item,
    }))
    .concat({
      href: `${domain}${path === '/' ? '' : path}`,
      hrefLang: 'x-default',
    });
};

const config = (locale: string, path: string) => {
  path = path.split('?')[0];
  return {
    canonical: `${domain}/${locale}${path === '/' ? '' : path}`,
    openGraph: {
      type: 'website',
      images: [{ url: `${s2Domain}${seoImagePath}` }],
      siteName: siteConfig.siteName,
    },
    twitter: {
      site: siteConfig.siteName,
      cardType: 'summary_large_image',
    },
  };
};

export default config;
